import React, { Component } from "react";
// import PropTypes from "prop-types";
import Loginpage from "../../Components/Pages/Login/Login";

export class Login extends Component {
  render() {
    return (
      <>
        <Loginpage />
      </>
    );
  }
}

export default Login;
